import { makeThemedStyles } from "qpr-base/viewcomponents/utils";

const useBudgetUtilizationCardStyles = makeThemedStyles(
  "BudgetUtilizationCard",
  (theme) => ({
    container: { display: "flex", flexDirection: "column", height: "100%" },
    card: {
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      width: "80%",
    },
    budgetSection: {
      display: "flex",
      flexDirection: "column",
    },
    title: {
      fontSize: "1.6em",
    },
    value: {
      fontSize: "18px",
      fontWeight: 600,
    },
    detailsSection: {
      display: "flex",
      flexDirection: "column",
      alignItems: "space-around",
      justifyContent: "end",
      gap: "6px",
    },
  })
);
export default useBudgetUtilizationCardStyles;
